import React from 'react';

const EventsToggleButton = ({ onClick, isActive }) => {
  return (
    <button
      className={`fab events-toggle-button ${isActive ? 'active' : ''}`}
      onClick={onClick}
      title={isActive ? "Ver Rondas" : "Ver Eventos"}
      aria-label={isActive ? "Alternar para modo de rondas" : "Alternar para modo de eventos"}
    >
      ⭐
    </button>
  );
};

export default EventsToggleButton;

